module.exports = __webpack_public_path__ + "static/supplierbg2_mobile-4b999e555b0a01638084121f70cbfa21.png";